import { IThemeState } from "./theme.types";

export const themeInitialState: IThemeState = {
  theme: sessionStorage.getItem('theme') as 'dark' | 'light' || 'dark'
};
